import {
    ableProps,
    ablePropsInit,
    events as baseEvents,
} from '../component-base/props';

export const props = () => [
    ...ableProps,
    {
        key: 'hint',
        label: '提示文字',
        type: 'string',
    },
    {
        key: 'hideTitle',
        label: '是否隐藏标题',
        type: 'boolean',
    },
    {
        key: 'sortable',
        label: '允许排序',
        type: 'boolean',
    },
    {
        key: 'autoCreateOne',
        label: '自动创建第一项',
        type: 'boolean',
    },
    {
        // 约定0为不处理
        key: 'min',
        label: '最少个数',
        type: 'number',
        props: {
            controls: false,
        },
    },
    {
        key: 'errMin',
        label: '最少个数提示文案',
        type: 'string',
    },
    {
        // 约定0为不处理
        key: 'max',
        label: '最大个数',
        type: 'number',
        props: {
            controls: false,
        },
    },
    {
        key: 'errMax',
        label: '最大个数提示文案',
        type: 'string',
    },
    {
        key: 'singleValue',
        label: '单个初始值',
        type: 'object',
    },
    {
        key: 'singleItem',
        label: '单个组件',
        type: 'form-config',
        config: {
            label: '单个组件',
            output: 'singleItem',
            deps: [],
            component: 'form-config',
            props: {},
        },
    },
];

export const init = () => ({
    ...ablePropsInit,
    hint: '',
    hideTitle: true,
    sortable: false,
    autoCreateOne: true,
    min: 0,
    errMin: '',
    max: 0,
    errMax: '',
    // JSON无法保存undefined，这个写了也没用
    // singleValue: undefined,
    singleItem: {},
});

export const name = '复制器';

export const component = 'mobile-general-form-array';

export const events = [
    'length-change',
    'length-increase',
    'length-decrease',
    ...baseEvents,
];